module.exports = __webpack_public_path__ + "media/images/menu/information-69e70031d44f09e1439f956d08ff059e.jpg";